import {useRef, useState} from 'react'
import {Banner} from '@primer/react'
import {StackIcon} from '@primer/octicons-react'
import {PreviewStackDialog} from './PreviewStackDialog'
import type {StackCreatedInfo} from './StackCreatedBanner'

export type CanStackBannerProps = {
  pullRequestNumber: number
  onStackCreated: (info: StackCreatedInfo) => void
  onDismiss: () => void
}

export function CanStackBanner({pullRequestNumber, onStackCreated, onDismiss}: CanStackBannerProps) {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false)
  const previewButtonRef = useRef<HTMLButtonElement>(null)

  const bannerText = 'This pull request can be stacked with other pull requests'

  return (
    <>
      <Banner
        aria-label={bannerText}
        title={bannerText}
        hideTitle
        description={bannerText}
        variant="info"
        leadingVisual={<StackIcon />}
        onDismiss={onDismiss}
        primaryAction={
          <Banner.PrimaryAction ref={previewButtonRef} onClick={() => setIsPreviewOpen(true)}>
            Preview stack
          </Banner.PrimaryAction>
        }
      />
      {isPreviewOpen && (
        <PreviewStackDialog
          currentPullNumber={pullRequestNumber}
          returnFocusRef={previewButtonRef}
          onClose={() => setIsPreviewOpen(false)}
          onStackCreated={onStackCreated}
        />
      )}
    </>
  )
}
